import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonService } from '@shared/common.service';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '@services/lang.service';
import CONFIG from '@config/app.config';
import URL_CONFIG from '@config/url.config';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FreeAgentsInterface } from '@interfaces/free-agents.interface';

@Injectable({
    providedIn: 'root',
})
export class FreeAgentsService {

    public constructor(
        private http: HttpClient,
        private common: CommonService,
        private trans: TranslateService,
        private lang: LangService,
    ) {
    }

    /**
     * Get Free Agents
     * @return [description]
     */
    public async getFreeAgents(
        tournamentId: any,
        year?: any,
    ): Promise<Observable<FreeAgentsInterface>> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        const url = URL_CONFIG.api.getFreeAgents;

        const params = new HttpParams()
            .set('lang', iso)
            .set('tournamentId', tournamentId ?? '')
            .set('year', year ?? '')
         ;

        const options = params ? { params } : {};
        return this.http.get<FreeAgentsInterface>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }

}
